import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import 'onsenui/css/onsenui.css';
import 'onsenui/css/onsen-css-components.css';
import VueOnsen from 'vue-onsenui';
Vue.use(VueOnsen);

VueOnsen.platform.select('ios');

import { ApiService } from './services/api.service';
import { SessionService } from './services/session.service';
import { MelosControllerService } from './services/melos-controller.service';

const sessionService = new SessionService(store);
const SessionServicePlugin = (V: typeof Vue, options?: any): void => {
  V.prototype.$sessionService = sessionService;
};
Vue.use(SessionServicePlugin);

const melosControllerService = new MelosControllerService(store);
const MelosControllerServicePlugin = (V: typeof Vue, options?: any): void => {
  V.prototype.$melosControllerService = melosControllerService;
};
Vue.use(MelosControllerServicePlugin);

const apiService = new ApiService(sessionService, store, router);
const ApiServicePlugin = (V: typeof Vue, options?: any): void => {
  V.prototype.$apiService = apiService;
};
Vue.use(ApiServicePlugin);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
